import { render } from "./photoList.vue?vue&type=template&id=4deca562&ts=true"
import script from "./photoList.vue?vue&type=script&lang=ts"
export * from "./photoList.vue?vue&type=script&lang=ts"

import "./photoList.vue?vue&type=style&index=0&id=4deca562&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__